import PageTabs, { PageTab } from 'component/PageTabs'
// import Comic from "./components/Comic";
import Short from './components/Short'
import Video from './components/Video'
import Comic from './components/Comic'

export default function BrowseHistory({ ...props }) {
  return (
    <PageTabs
      {...props}
      title="浏览纪录"
      tabs={[
        { id: 'video', name: '长视频' },
        { id: 'short', name: '短视频' },
        ...(process.env.REACT_APP_HAS_PROFILE_COMIC_SUB_PAGE ? [{ id: 'comic', name: '漫画' }] : []),
      ]}
      onClose={({ close }: { close: () => void }) => {
        close()
      }}
    >
      <PageTab>
        <Video />
      </PageTab>
      <PageTab>
        <Short />
      </PageTab>
      {process.env.REACT_APP_HAS_PROFILE_COMIC_SUB_PAGE ? (
        <PageTab>
          <Comic />
        </PageTab>
      ) : null}
    </PageTabs>
  )
}
